import { render } from "./LeadsTitleCard.vue?vue&type=template&id=ef6531b4"
import script from "./LeadsTitleCard.vue?vue&type=script&lang=js"
export * from "./LeadsTitleCard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__